import axios from 'axios';

import environment from 'environment';
import authService from './auth';
import NotificationService from './notification';
import i18n from 'i18n';

export const axiosRequestInterceptor = () => {
	axios.interceptors.request.use(
		(config) => {
			config.headers['APP-ID'] = environment.APP_ID;
			config.headers['APP-KEY'] = environment.APP_KEY;
			config.headers['X-Locale'] = i18n.language;

			const token = authService.getToken();
			if (token) config.headers['Authorization'] = 'Bearer ' + token;

			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			if (!error.request.responseURL.includes('login') && error.status === 401) {
				authService.clearAuthData();
				NotificationService.error('Unauthorized', 'please re-login again');
				window.history.pushState({}, '', '/login');
				window.dispatchEvent(new PopStateEvent('popstate'));
			}

			return Promise.reject(error);
		},
	);
};
